var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucessStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57143 17.5725C13.3053 17.5725 17.1429 13.735 17.1429 9.00112C17.1429 4.26725 13.3053 0.429688 8.57143 0.429688C3.83756 0.429688 0 4.26725 0 9.00112C0 13.735 3.83756 17.5725 8.57143 17.5725ZM8.57143 16.4297C4.46874 16.4297 1.14286 13.1038 1.14286 9.00112C1.14286 4.89843 4.46874 1.57254 8.57143 1.57254C12.6741 1.57254 16 4.89843 16 9.00112C16 13.1038 12.6741 16.4297 8.57143 16.4297ZM4.7388 8.59706C4.96195 8.3739 5.32376 8.3739 5.54692 8.59706L7.42857 10.4787L11.5959 6.31134C11.8191 6.08818 12.1809 6.08818 12.4041 6.31134C12.6272 6.5345 12.6272 6.89631 12.4041 7.11946L7.87304 11.6505C7.62757 11.896 7.22958 11.896 6.9841 11.6505L4.7388 9.40518C4.51564 9.18202 4.51564 8.82021 4.7388 8.59706Z",
    fill: "#5B8E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessStatus);
export default __webpack_public_path__ + "static/media/sucess-status.c1313b9e.svg";
export { ForwardRef as ReactComponent };